export default "__VITE_PUBLIC_ASSET__9fb22661__"